import { render, staticRenderFns } from "./codeImg.vue?vue&type=template&id=ded56fbe&scoped=true&"
import script from "./codeImg.vue?vue&type=script&lang=js&"
export * from "./codeImg.vue?vue&type=script&lang=js&"
import style0 from "./codeImg.vue?vue&type=style&index=0&id=ded56fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded56fbe",
  null
  
)

export default component.exports